import { ViewFactory } from 'wdc-cube-react'
import DialogoResultadoScope from '../dialogo-resultado.scopes'
import DialogoResultadoView from './dialogo-resultado.view'

export function registerViews(rv = ViewFactory.register) {
    rv(DialogoResultadoScope, DialogoResultadoView)
}
